import React, { FC } from 'react';

import { Stack } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';

import { ChatService } from '@diagram/services/ChatService';

import { DiagramChatChannel } from 'models';
import { ChatHelpers } from 'helpers/ChatHelpers';

import { Form } from 'components/forms/Form';
import { FormSubmit } from 'components/forms/FormSubmit';
import { TextField } from 'components/forms/fields/TextField';
import { ModalTitle } from 'components/modals/ModalTitle';

const UpdateChatChannel: FC<
    ContextModalProps<{
        channel: DiagramChatChannel;
    }>
> = ({ context, innerProps }) => {
    const { channel } = innerProps;

    const submit = async (values: DiagramChatChannel) => {
        await ChatService.updateChannel({ id: channel.id, name: values.name });

        context.closeAll();
    };

    return (
        <Stack gap="xs">
            <ModalTitle align="left">Channel Settings</ModalTitle>
            <Form<DiagramChatChannel> defaultValues={channel} onSubmit={submit}>
                <Stack gap="md">
                    <TextField name="name" label="Name" leftSection="#" transform={ChatHelpers.transformChannelName} />
                    <FormSubmit>Update channel</FormSubmit>
                </Stack>
            </Form>
        </Stack>
    );
};

export { UpdateChatChannel };
